import state from '../state';
import type { ContentForDevice } from '../types';

export function getViewportValue<T>(config: ContentForDevice<T>): T;
export function getViewportValue<T>(config: ContentForDevice<T>, property: keyof T): T[keyof T];
export function getViewportValue<T>(config: ContentForDevice<T>, property?: keyof T): T | T[keyof T] {
  if (!config) return;

  const valueForViewport = state.isMobileViewport ? config.mobile ?? config.computer : config.computer;
  return property ? valueForViewport[property] : valueForViewport;
}
